<i18n lang='yml' src='../i18n/LogbookHours.yml'></i18n>
<template>
  <Form class="flex-edit" ref="observer"  v-slot="{ errors }" @submit="submitUserInput" @invalid-submit="setErrorMessage">
      <div class="flex-table-hours" role="rowgroup">
        <div class="flex-row flex-row-short first" role="cell">
          <Field
            :name="$t('start_date')"
            :rules="`required|start_date_before_end_date:@${$t('end_date')}`"
            v-slot="{ errors, field }"
            v-model="logbook_hours.start_date">
            <label class='d-none' for='start_date_datepicker'>{{ $t('start_date') }}</label>
            <flat-pickr id='start_date_datepicker' class="form-control" :class="{'is-invalid': errors[0]}" name="date_picker"  time="" :config='dateConfig' v-bind="field"></flat-pickr>
            <div class="invalid-feedback" id="time_allowance_error" v-if="errors[0]">
              <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
              <span>{{ errors[0] }}</span> 
            </div>
          </Field>
        </div>
        <div class="flex-row flex-row-short" role="cell">
          <Field
            :name="$t('end_date')"
            rules="required"
            v-slot="{ errors, field }"
            v-model='logbook_hours.end_date'>
            <label class='d-none' for='end_date_datepicker'>{{ $t('end_date') }}</label>
            <flat-pickr id='end_date_datepicker' class="form-control" :class="{'is-invalid': errors[0]}" name="date_picker"  time="" :config='dateConfig' v-bind="field"></flat-pickr>
            <div class="invalid-feedback" id="time_allowance_error" v-if="errors[0]">
              <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
              <span>{{ errors[0] }}</span> 
            </div>
          </Field>
        </div>
        <div class="flex-row flex-row-long" role="cell">
          <Field
            :name="$t('hours_column')"
            rules="required|greater_than_zero|decimal_places:2|less_than:1000000"
            v-slot="{ errors, field }"
            v-model.number="logbookHoursDisplay">
            <label class='d-none' :for="$t('hours_column')" >{{ $t('hours_column') }}</label>
            <input
              class="form-control"
              ref="log_hours"
              :class="{'is-invalid': errors[0]}"
              :id="$t('hours_column')"
              name="log_hours"
              :label="$t('hours_column')"
              v-bind="field"
              className="col-sm-12 no-padding"
            />
            <div class="invalid-feedback" id="time_allowance_error" v-if="errors[0]">
              <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
              <span>{{ errors[0] }}</span> 
            </div>
          </Field>
        </div>
        <div class="flex-row flex-row-short" role="cell">
          <button class="btn btn-sm btn-outline-secondary btn-comment" @click.prevent disabled>
            <label class="sr-only" for="comment_button"> {{ addSrLabel(logbook_hours.comment) }} </label>
            <font-awesome-icon :icon="['far', 'comment-alt']" v-if="logbook_hours.comment==''"/>
            <font-awesome-icon :icon="['fas', 'comment-alt-check']" v-else/>
          </button>
        </div>
        <div class="flex-row flex-row-short" role="cell">
          <span class="status-bold" v-if="type == 'edit'">
            {{ $t(logbook_hours.status) }}
          </span>
        </div>
        <div class="flex-row flex-row-short" role="cell">
        </div>
      </div>
      <div class="flex-table-hours">
        <div class="flex-row-full" role="cell">
          <label for="comment"> {{ $t('add_comment') }} </label>
          <textarea rows="4" id="comment" name="comment" class="live-editor form-control" v-model="logbook_hours.comment"></textarea>
        </div>
        <div class="flex-row-full d-flex" role="cell">
          <button class="btn btn-primary btn-success no-shadow">
            {{ $t('action_buttons.save')}}
          </button>
          <a class="btn btn-light ml-auto" @click="closeComment">
            {{ $t('action_buttons.cancel')}}
          </a>
        </div>
      </div>
  </Form>
</template>
<script>
  import { French } from 'flatpickr/dist/l10n/fr.js';
  import LoadingAnimation from '../../shared/loader/components/LoadingAnimation.vue';
  import '../../../javascripts/application/vee-validate-rules.js'
  import { Form, Field } from 'vee-validate'
  import { sendAjaxRequest, ajaxResponseMessage } from '../../shared/typescripts/ajax.ts'
  import { formatDate } from '../../shared/typescripts/dates.ts'

  export default {
    props: [
      'locale',
      'container_training_agreement',
      'logbook',
      'load_path',
      'type',
      'logbook_hour',
      'approved',
      'total'
    ],
    components: {
      'loading-animation': LoadingAnimation,
      Form,
      Field
    },
    data() {
      return {
        logbook_hours: {
          start_date: formatDate(new Date()),
          end_date: formatDate(new Date()), 
          hours: 0,
          comment: '',
          status: 0,
          container_training_agreement_id: this.container_training_agreement.id,
          logbook_id: this.logbook.id
        },
        dateConfig: {
          enableTime: false,
          maxDate: new Date(),
          locale: (this.locale=='fr') ? French : 'en',
          onChange: function(selectedDates, dateStr, instance) {
            selectedDates.length > 0 ? selectedDates[0].toISOString() : ''
          }
        },
        message_text: [],
        message_type: "",
        responses: [],
        row_id: null,
        showErrorBanner: false,
      }
    },
    mounted() {
      try {
        if(this.logbook_hour){
          this.logbook_hours = this.logbook_hour;
          this.row_id = this.logbook_hour.id;
        }
      }
      catch(err) {
        this.error = true;
      }
    },
    computed: {
      logbookHoursDisplay: {
        get: function() {
          return !this.logbook_hours || this.logbook_hours.hours === '' ? '' : this.logbook_hours.hours;
        },
        set: function(newValue) {
          this.logbook_hours.hours = newValue
        }
      },
    },
    methods: {
      closeComment() {
        this.$emit('closeHourFormRow', {
          type: this.type,
          row_id: this.row_id
        })
      },
      addSrLabel(comment){
        if(comment && comment !== ""){
          return this.$t('sr_comment_exists');
        }
        else return this.$t('sr_comment_null');
      },
      flashEvent(){
        this.$emit('setFlash', {
          type: this.message_type,
          text: this.message_text
        })
      },
      submitUserInput(){
        this.logbook_hours.hours = parseFloat(this.logbook_hours.hours)
        if(this.logbook_hours.hours + this.approved > this.total && !confirm(this.$t('confirm_add_extra_hours'))) {
          return
        }
        let payload = []
        payload = { logbook_hour: this.logbook_hours }
        // as the start & end date are being set in the date picker without a time we set one using new date
        // that will create a timevalue and convert it to a utc date/time string for the api otherwise
        // the api date validation will fail as it would think that a start_date and end_date of the same day are identical.
        if ((payload.logbook_hour.start_date == payload.logbook_hour.end_date) && payload.logbook_hour.start_date != null){
          payload.logbook_hour.start_date = new Date(`${payload.logbook_hour.start_date} 00:00`).toUTCString();
          payload.logbook_hour.end_date = new Date(`${payload.logbook_hour.end_date} 23:59`).toUTCString();
        }
        //
        //We need to emit an event with empty params to reset the flash otherwise it won't show up more than once.
        this.message_type = '';
        this.message_text = [];
        this.flashEvent();
        let send_type = 'POST'
        let path = this.load_path
        if (this.type == "edit") {
          send_type = "PUT"
          path = `${path}/${this.row_id}`
        }
        sendAjaxRequest(send_type, path, 'json', payload, ajaxResponseMessage, this.throwError)
      },
      throwError(response) {
        this.message_type = "error";
        this.message_text.push(response.responseJSON.error)
        this.flashEvent();
        console.log(response);
      }
    },
  }
</script>
